<template>
  <div class="login">
    <a @click="login">Login</a>
  </div>
</template>

<script>
  export default {
    name: 'login',
    created: function () {
      this.$on('docendo_state', function (data) {
        if (data === 'connected') {
          this.connected()
        } else if (data === 'disconnected') {
          this.disconnected()
        }
      })
    },
    methods: {
      connected: function () {
      },
      disconnected: function () {
      },
      login: function () {
        var location = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
        console.log(location)
      }
    },
    data () {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?760f8e80